import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/opciones`, options)
    .then(response => {
      return {
        list: response.data,
        meta: response.data.meta
      };
    });
}

function update(opciones) {
  const payload = jsona.serialize({
    stuff: opciones,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/opciones/${opciones}`, payload, options)
    .then(response => {
      return response.data;
    });
}

export default {
  list,
  update
};

